import { render, staticRenderFns } from "./counties.vue?vue&type=template&id=5672c729&"
import script from "./counties.vue?vue&type=script&lang=js&"
export * from "./counties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports